"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HowWeWork() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="4466" id="how-we-work" className="bg-[#2D343E] text-slate-50 relative overflow-hidden">
      <div className="grid grid-cols-1 min-h-screen">
        {}
        <div className="relative flex items-center justify-center px-6 py-16 sm:px-12 sm:py-24 lg:px-16 xl:px-24 lg:py-32">
          <div className="w-full max-w-xl">
            {}
            <div ref={headingRef} className="transition-all duration-700 ease-out" style={{
            opacity: headingVisible ? 1 : 0,
            transform: headingVisible ? "translateY(0)" : "translateY(16px)"
          }}>
              <div className="flex items-center gap-4 mb-10">
                <span className="block h-px w-10 bg-cyan-500" />
                <span className="font-mono text-xs uppercase tracking-[0.4em] text-cyan-500">
                  04 — Our Service Methodology
                </span>
              </div>

              {}
              <h2 className="font-default text-4xl sm:text-5xl lg:text-6xl xl:text-7xl leading-[1.02] tracking-tight text-slate-50" style={{
              fontFamily: "var(--font-serif)"
            }}>
                Stability.{" "}
                <span className="block italic text-cyan-500/90">
                  The foundation
                </span>
                <span className="block">of every</span>
                <span className="block italic">individual.</span>
              </h2>

              <p className="mt-8 max-w-md text-base text-slate-300 leading-relaxed font-sans">
                At Waters Well Inc., we believe that every person deserves a 
                structured, supportive environment where their potential can 
                truly expand and flourish.
              </p>
            </div>

            {}
            <div className="mt-16 flex items-center gap-5">
              <span className="block h-px w-12 bg-cyan-500/60" />
              <p className="italic text-base sm:text-lg text-slate-100/80" style={{
              fontFamily: "var(--font-serif)"
            }}>
                Committed to excellence in Connecticut DDS services.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}